import React from "react";
import { useParams } from "react-router-dom";

import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import StandardFileViewerPage from "./StandardFileViewerPage";

export default function ImageViewerPage() {
    const { imageKey } = useParams();

    return (
        <StandardFileViewerPage
            fileKey={imageKey}
            routeSegment="image"
            mediaBackground="#151a17"
            renderMedia={(file) => (
                <Box
                    sx={{
                        minHeight: { xs: 260, sm: 420 },
                        maxHeight: "68vh",
                        display: "grid",
                        placeItems: "center",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        component="img"
                        src={file.url}
                        alt={file.displayName}
                        sx={{
                            display: "block",
                            width: "100%",
                            height: "100%",
                            maxHeight: "68vh",
                            objectFit: "contain",
                        }}
                    />
                </Box>
            )}
            renderAdditionalActions={(file) => (
                <Button
                    component="a"
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    size="small"
                    startIcon={<FullscreenIcon />}
                    sx={{
                        flex: {
                            xs: "1 1 calc(50% - 4px)",
                            sm: "0 0 auto",
                        },
                    }}
                >
                    Full screen
                </Button>
            )}
        />
    );
}
